import { faChartPie } from '@fortawesome/pro-light-svg-icons';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@sixui/ui';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Heading } from '~/components/molecules/Heading';
import { AppBreadcrumbs } from '~/components/organisms/Breadcrumbs';
import { PollList } from '~/components/organisms/PollList';

export type IAppPollsPageProps = {
  appId: string;
};

export const AppPollsPage: React.FC<IAppPollsPageProps> = (props) => {
  const { appId } = props;
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('AppPollsPage.seo.title')}</title>
      </Helmet>
      <AppBreadcrumbs appId={appId} />
      <Heading
        icon={<FontAwesomeIcon icon={faChartPie} />}
        title={t('AppPollsPage.title')}
        subtitle={t('AppPollsPage.subtitle')}
        actions={
          <Button
            href={`/apps/${appId}/polls/create`}
            icon={<FontAwesomeIcon icon={faPlus} />}
          >
            {t('AppPollsPage.create')}
          </Button>
        }
      />
      <PollList appId={appId} />
    </>
  );
};
